import React from 'react';
import styled from '@emotion/styled';
import { text } from 'style/mixin';
import { CareerDetailHeading } from 'components/unique/careerDetail/careerDetailHeading';
import { mq } from 'style/variables';

type TitleContentRowProps = {
  titleEn: string;
  titleJa: string;
  titleTh?: string;
  children: React.ReactNode;
  contentWidth?: number;
};

const TitleContentRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${mq.onlysp} {
    flex-direction: column;
    gap: 30px;
  }
`;

const CareerDetailContent = styled.div<{ contentWidth?: number }>`
  width: ${props => (props.contentWidth ? `${props.contentWidth}px` : '748px')};
  ${text(16, 1.8)}
  color: #333;

  ${mq.onlysp} {
    width: 100%;
    ${text(17, 1.8)}
  }
`;

export const TitleContentRow = ({ titleEn, titleJa, titleTh, children, contentWidth }: TitleContentRowProps) => {
  return (
    <TitleContentRowWrapper>
      <CareerDetailHeading titleEn={titleEn} titleJa={titleJa} titleTh={titleTh} />
      <CareerDetailContent contentWidth={contentWidth}>{children}</CareerDetailContent>
    </TitleContentRowWrapper>
  );
};
